import * as types from "../../mutationTypes";
import areaService from "services/areaService";

const actions = {
  async getAll ({ commit, state, dispatch }, force) {
    if (!state.items || state.items.length === 0 || force) {
      dispatch('app/loadingDataEnable', 'codeListItems', {root: true});
      const areas = await areaService.findAll();
      await commit(types.AREA_LIST, {
        items: areas || []
      });
      dispatch('app/loadingDataDisable', 'codeListItems', {root: true});
    }
  },
  async create ({dispatch, commit}, area) {
    let newArea = await areaService.create(area);
    if (newArea) {
      dispatch('getAll', true);
      return true;
    } else {
      return false;
    }
  },
  async update ({dispatch, commit}, area) {
    let updatedArea = await areaService.update(area);
    if (updatedArea) {
      dispatch('getAll', true);
      return true;
    } else {
      return false;
    }
  },
  async delete ({dispatch, commit}, id) {
    let response = await areaService.delete(id);
    if (response.ok) {
      dispatch('getAll', true);
      return true;
    } else {
      return false;
    }
  },
  async deactivate ({ dispatch }, id) {
    let response = await areaService.deactivate(id);
    if (response.ok) {
      dispatch('getAll', true);
      return true;
    } else {
      return false;
    }
  },
  async activate ({ dispatch }, id) {
    let response = await areaService.activate(id);
    if (response.ok) {
      dispatch('getAll', true);
      return true;
    } else {
      return false;
    }
  }
};

export default actions



// WEBPACK FOOTER //
// ./client/store/modules/area/areaActions.js